$('.nav-menu-item .title').on('click', function () {
  if ($(this).siblings('.menu-dropdown').length) {
      $('.main-menu__headers').empty();
      // console.log('#####empty', $(this).parent().find('.menu-dropdown-head').clone(true));
      const $item = $(this).parent().find('.menu-dropdown-head').clone();
      $item.attr('data-index', $(this).parent().index());
      $('.main-menu__headers').append($item);
  }
});

$(document).on('click', '.main-menu__headers .menu-dropdown-title', function() {
  $('.nav-menu-item').eq(+$(this).parent().attr('data-index')).find('.menu-dropdown-title').trigger('click');
})
